/* Custom Gifting — Engraving Preview
   Vanilla, no deps, idempotent, instance-scoped, morph-safe.
   Wires <input> → <svg><text>, char counter, overcap warning,
   "send to inquiry" CustomEvent, GA4 events (existing G-W9H3WFRZKC, guarded). */
(function () {
  if (window.PoAEngravingPreview && window.PoAEngravingPreview.__loaded) return;

  function track(name, params) {
    if (typeof window.gtag === 'function') {
      try { window.gtag('event', name, params || {}); } catch (e) {}
    }
  }

  function init(root) {
    if (!root || root.dataset.poaEngraveInit === '1') return;
    root.dataset.poaEngraveInit = '1';

    var input = root.querySelector('[data-poa-engrave-input]');
    var svgText = root.querySelector('[data-poa-engrave-text]');
    var srOut = root.querySelector('[data-poa-engrave-srout]');
    var count = root.querySelector('[data-poa-engrave-count]');
    var helper = root.querySelector('[data-poa-engrave-helper]');
    var prompt = root.querySelector('[data-poa-engrave-prompt]');
    var primary = root.querySelector('[data-poa-engrave-send]');
    var secondary = root.querySelector('[data-poa-engrave-reset]');
    if (!input || !svgText) return;

    function showPrompt() {
      if (!prompt) return;
      prompt.hidden = false;
      // next frame so the .is-visible transition has a starting state to animate from
      window.requestAnimationFrame(function () { prompt.classList.add('is-visible'); });
    }
    function hidePrompt() {
      if (!prompt) return;
      prompt.classList.remove('is-visible');
      prompt.hidden = true;
    }

    var maxChars = parseInt(root.dataset.maxChars, 10) || 24;
    var defaultText = root.dataset.defaultText || 'Your Brand';
    var initialValue = input.value || '';
    var helperBase = (helper && helper.dataset.base) || (helper ? helper.textContent : '');
    var helperOver = (helper && helper.dataset.over) || helperBase;
    var started = false;
    var overcapReported = false;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var zoneWVB       = parseFloat(svgText.dataset.zoneWVb)       || 608;
    var baseFontSize  = parseFloat(svgText.dataset.baseFontSize)  || 96;
    var MIN_SCALE     = 0.65;
    var fitPending    = false;

    function fitText() {
      if (fitPending) return;
      fitPending = true;
      window.requestAnimationFrame(function () {
        fitPending = false;
        svgText.removeAttributeNS(null, 'textLength');
        svgText.setAttribute('font-size', baseFontSize);
        var natural = 0;
        try { natural = svgText.getBBox().width; } catch (e) { return; }
        if (!natural) return;
        var scale = Math.min(1, zoneWVB / natural);
        if (scale < MIN_SCALE) scale = MIN_SCALE;
        var nextSize = baseFontSize * scale;
        svgText.setAttribute('font-size', nextSize.toFixed(2));
        if ((natural * scale) > zoneWVB + 0.5) {
          svgText.setAttribute('textLength', zoneWVB);
          svgText.setAttribute('lengthAdjust', 'spacingAndGlyphs');
        }
      });
    }

    function render(raw) {
      var s = (raw || '').toString();
      var visible = s.length > maxChars ? s.slice(0, maxChars) : s;
      var text = visible.length ? visible : defaultText;
      svgText.textContent = text;
      fitText();
      if (srOut) srOut.textContent = visible.length ? ('Engraving preview: ' + visible) : '';
      var over = s.length > maxChars;
      if (count) {
        count.textContent = s.length + ' / ' + maxChars;
        count.classList.toggle('is-overcap', over);
      }
      input.classList.toggle('is-overcap', over);
      if (helper) helper.textContent = over ? helperOver : helperBase;
      if (over && !overcapReported) {
        overcapReported = true;
        track('cg_engraving_chars_overcap', { page: 'custom-gifting', length: s.length });
      }
    }

    function onInput() {
      if (!started) {
        started = true;
        track('cg_engraving_preview_start', { page: 'custom-gifting' });
      }
      if (input.value && input.value.trim()) hidePrompt();
      render(input.value);
    }

    function onSend(e) {
      e.preventDefault();
      var rawValue = (input.value || '').toString().trim();
      if (!rawValue) {
        showPrompt();
        try { input.focus(); } catch (err) {}
        track('cg_engraving_send_empty', { page: 'custom-gifting' });
        return;
      }
      hidePrompt();
      try {
        document.dispatchEvent(new CustomEvent('cg:engraving-set', {
          detail: { text: rawValue }
        }));
      } catch (err) {}
      track('cg_engraving_to_inquiry', { page: 'custom-gifting', length: rawValue.length });
      var target = document.getElementById('cg-inquiry-form');
      if (target) target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    }

    function onReset(e) {
      e.preventDefault();
      input.value = '';
      hidePrompt();
      render('');
      input.focus();
    }

    input.addEventListener('input', onInput, { passive: true });
    if (primary) primary.addEventListener('click', onSend);
    if (secondary) secondary.addEventListener('click', onReset);

    render(initialValue);
    setupMotion(root, reduce);
  }

  function setupMotion(root, reduce) {
    if (reduce) return;
    if (root.dataset.motionEnabled === '0') return;
    var stage = root.querySelector('[data-poa-engrave-stage]');
    var motion = root.querySelector('[data-poa-engrave-motion]');
    if (!stage || !motion) return;
    var hoverable = !(window.matchMedia && window.matchMedia('(hover: none)').matches);
    if (!hoverable) return;

    var tiltMax = parseFloat(root.dataset.motionTiltMax);
    if (isNaN(tiltMax) || tiltMax <= 0) return;

    var pending = false;
    var lastX = 0;
    var lastY = 0;
    var rect = null;

    function apply() {
      pending = false;
      if (!rect) return;
      var nx = (lastX - rect.left) / rect.width;
      var ny = (lastY - rect.top) / rect.height;
      if (nx < 0) nx = 0; else if (nx > 1) nx = 1;
      if (ny < 0) ny = 0; else if (ny > 1) ny = 1;
      var rotY = (nx - 0.5) * 2 * tiltMax;
      var rotX = (0.5 - ny) * 2 * (tiltMax * 0.75);
      motion.style.setProperty('--poa-engrave-tilt-y', rotY.toFixed(2) + 'deg');
      motion.style.setProperty('--poa-engrave-tilt-x', rotX.toFixed(2) + 'deg');
    }

    stage.addEventListener('mouseenter', function () {
      rect = stage.getBoundingClientRect();
    });
    stage.addEventListener('mousemove', function (e) {
      lastX = e.clientX;
      lastY = e.clientY;
      if (!rect) rect = stage.getBoundingClientRect();
      if (!pending) {
        pending = true;
        window.requestAnimationFrame(apply);
      }
    }, { passive: true });
    stage.addEventListener('mouseleave', function () {
      motion.style.setProperty('--poa-engrave-tilt-y', '0deg');
      motion.style.setProperty('--poa-engrave-tilt-x', '0deg');
      rect = null;
    });
    window.addEventListener('scroll', function () { rect = null; }, { passive: true });
    window.addEventListener('resize', function () { rect = null; }, { passive: true });
  }

  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll('[data-poa-engrave-root]');
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }

  window.PoAEngravingPreview = { init: init, initAll: initAll, __loaded: true };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Survive Section Rendering API / morph re-renders.
  document.addEventListener('shopify:section:load', function (e) {
    if (e && e.target) initAll(e.target);
  });
})();
